import { useQuery } from '@tanstack/react-query'
import { usersApi } from '../../lib/api'
import { PageLoading } from '../../components/LoadingSpinner'
import type { Role } from '../../types/api'

const ROLE_LABELS: Record<Role, string> = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN_TENANT: 'Administrador',
  GESTOR_RH: 'Gestor RH',
  OPERADOR: 'Operador',
  FUNCIONARIO: 'Funcionário',
}

const ROLE_BADGE: Record<Role, string> = {
  SUPER_ADMIN: 'badge-red',
  ADMIN_TENANT: 'badge-blue',
  GESTOR_RH: 'badge-green',
  OPERADOR: 'badge-yellow',
  FUNCIONARIO: 'badge-gray',
}

export function UsersPage() {
  const { data: users, isLoading, isError } = useQuery({
    queryKey: ['users'],
    queryFn: usersApi.list,
  })

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-6)' }}>
        <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700 }}>Usuários</h1>
        {/* TODO: botão de convidar usuário (requer endpoint POST /users) */}
      </div>

      <div className="card" style={{ padding: 0 }}>
        {isLoading ? (
          <div style={{ padding: 'var(--space-8)' }}>
            <PageLoading />
          </div>
        ) : isError ? (
          <div className="alert alert-danger" style={{ margin: 'var(--space-4)' }}>
            Não foi possível carregar os usuários.
          </div>
        ) : !users?.length ? (
          <EmptyState message="Nenhum usuário cadastrado." />
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>E-mail</th>
                  <th>Papel</th>
                  <th>ID</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>{u.email}</td>
                    <td>
                      <span className={`badge ${ROLE_BADGE[u.role]}`}>
                        {ROLE_LABELS[u.role]}
                      </span>
                    </td>
                    <td style={{ color: 'var(--color-gray-400)', fontSize: 'var(--font-size-xs)' }}>
                      {u.id.slice(0, 8)}…
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

function EmptyState({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 'var(--space-16)',
        textAlign: 'center',
        color: 'var(--color-gray-400)',
        fontSize: 'var(--font-size-sm)',
      }}
    >
      {message}
    </div>
  )
}
